import React from "react";
import {ClassInjector} from "../../../../../injectors";
import {ClassNameDecorator} from "../../../../../decorators";
import {ChildrenProps} from "../../../../../../utils";
import './TertiaryHeading.scoped.scss';

const TertiaryHeading: ClassNameDecorator<ChildrenProps> = ({children, className}) => {
  return (
    <ClassInjector classNames="tertiary-heading" oldClassName={className}>
      { children }
    </ClassInjector>
  );
};

export default TertiaryHeading;